import { UseFormSetValue } from "react-hook-form";
import { ClientSearchResult } from "state/queries/useClientSearch";

/**
 * Populates form fields with GOS client data
 * This logic is shared between client search dialog and prefill auto-population
 */
export function populateClientDataFromGOS(
  client: ClientSearchResult,
  setValue: UseFormSetValue<any>
): void {
  const isCompany = client.isCompany;

  setValue("clientData.clientType", isCompany ? "company" : "person");
  setValue("clientData.isExistingInGOS", true);

  if (isCompany) {
    setValue("clientData.clientName", client.partnerName || "");
    setValue("clientData.clientFirstName", "");
    setValue("clientData.clientLastName", "");
  } else {
    setValue("clientData.clientName", "");
    setValue("clientData.clientFirstName", client.firstName || "");
    setValue("clientData.clientLastName", client.lastName || "");
  }

  // Client code: company register number for companies,
  // personal identification number for private persons
  if (isCompany) {
    if (client.companyRegisterNumber) {
      setValue("clientData.clientCode", client.companyRegisterNumber);
    } else if (client.partnerNumber) {
      setValue("clientData.clientCode", client.partnerNumber);
    }
  } else {
    setValue("clientData.clientCode", client.personIdentificationNumber || "");
  }

  if (client.isResident !== undefined) {
    setValue("clientData.resident", client.isResident);
  }

  if (client.partnerMainSicCode !== undefined) {
    setValue("clientData.partnerMainSicCode", client.partnerMainSicCode);
  }

  if (client.partnerAddress) {
    const addr = client.partnerAddress;
    const addressParts: string[] = [];
    if (addr.street) addressParts.push(addr.street);
    if (addr.house) addressParts.push(addr.house);
    if (addr.buildingFloorDoor) addressParts.push(addr.buildingFloorDoor);
    if (addressParts.length > 0) {
      setValue("clientData.address", addressParts.join(", "));
    }
    if (addr.city) setValue("clientData.city", addr.city);
    if (addr.street) setValue("clientData.cityAddress", addr.street);
    if (addr.zipCode) setValue("clientData.postIndex", addr.zipCode);
  }

  if (client.partnerMail?.emailAddress) {
    setValue("clientData.clientEmail", client.partnerMail.emailAddress);
  }

  if (client.partnerPhone) {
    const phone = client.partnerPhone;
    const phoneParts: string[] = [];
    if (phone.phoneCountry) phoneParts.push(`+${phone.phoneCountry}`);
    if (phone.phoneArea) phoneParts.push(phone.phoneArea);
    if (phone.phoneNumber) phoneParts.push(phone.phoneNumber);
    if (phone.phoneExtension) phoneParts.push(`ext ${phone.phoneExtension}`);
    if (phoneParts.length > 0) {
      setValue("clientData.clientPhoneNumber", phoneParts.join(" "));
    }
  }
}
